// import React, { useEffect, useState } from 'react';
// import { Container, Row, Col, Card, Tab, Tabs, Nav } from 'react-bootstrap';
// import Footer from './Footer';
// import { Helmet } from 'react-helmet';
// import axios from 'axios';
// import parse from 'html-react-parser';

// function Projects() {
//   const projectData = {
//     ResidentialProjects: [
//       {
//         name: "Al Hail Villas",
//         description: "Installation of Hyundai home elevators in a luxury villa complex, enhancing accessibility and adding a touch of sophistication to each home.",
//         image: "/Images/gallery/1.jpg"
//       },
//       {
//         name: "Muscat Heights Apartments",
//         description: "Deployment of passenger elevators in a high-rise residential building, ensuring smooth and efficient transportation for residents.",
//         image: "/Images/gallery/3.jpg"
//       }
//     ],
//     CommercialProjects: [
//       {
//         name: "Oman Business Tower",
//         description: "Implementation of high-capacity passenger elevators in a premier office building, improving the flow of people and enhancing the overall user experience.",
//         image: "/Images/gallery/4.jpg"
//       },
//       {
//         name: "City Centre Mall",
//         description: "Installation of escalators and moving walks to facilitate seamless movement of shoppers across multiple floors and sections of the mall.",
//         image: "/Images/gallery/5.jpg"
//       }
//     ],
//     HospitalityProjects: [
//       {
//         name: "Grand Hyatt Muscat",
//         description: "Integration of Hyundai elevators in a five-star hotel, providing guests with a luxurious and comfortable vertical transportation experience.",
//         image: "/Images/gallery/8.jpg"
//       },
//       {
//         name: "Beach Resort Salalah",
//         description: "Deployment of passenger and service elevators to meet the high demands of a bustling resort environment.",
//         image: "/Images/gallery/9.jpg"
//       }
//     ],
//     PublicSectorProjects: [
//       {
//         name: "Muscat International Airport",
//         description: "Installation of moving walks and escalators to ensure efficient passenger movement through the airport terminals.",
//         image: "/Images/gallery/10.jpg"
//       },
//       {
//         name: "Royal Hospital",
//         description: "Installing Hyundai elevators to enhance accessibility and streamline transportation for patients and staff throughout the hospital.",
//         image: "/Images/gallery/11.jpg"
//       }
//     ],
//     IndustrialProjects: [
//       {
//         name: "Sohar Industrial Port",
//         description: "Installing freight elevators to meet the heavy-duty transportation demands of an industrial port facility.",
//         image: "/Images/gallery/12.jpg"
//       },
//       {
//         name: "Oman Cement Company",
//         description: "Deployment of robust and reliable freight elevators to facilitate the movement of goods and materials within the plant.",
//         image: "/Images/gallery/13.jpg"
//       }
//     ]
//   };

//   const [activeTab, setActiveTab] = React.useState(Object.keys(projectData)[0]);
//   const [isSticky, setIsSticky] = useState(false);

//   const [project, setProject] = useState()

//   const handleScroll = () => {
//     if (window.scrollY > 100) {
//       setIsSticky(true);
//     } else {
//       setIsSticky(false);
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {

//     const fetchData = async () => {
//       try {
//         const respose = await axios.get('https://admin.techno-elevators.com/api/getProjectsPageDataBySlug/projects')
//         setProject(respose.data.data)
//       }
//       catch (err) {
//         console.log(err)
//       }

//     }
//     fetchData()
//   }, [])


//   return (
//     <div>
//       <Helmet>
//         <title>Projects | Best Escalators & Elevators For Sale in Oman</title>
//         <meta name="description" content="Discover the future of vertical transport with Techno Elevators. You can trust us by looking at our projects done by our expert team." />

//       </Helmet>
//       <Container fluid>
//         {/* Header Section */}
//         <Row className="text-center mt-5 mb-3">
//           <div className="section-title">
//             <h2>Our Projects</h2>
//           </div>
//           <Col lg={12}>
//             <p className="text-center" style={{ width: '700px', margin: 'auto' }}>
//               {project?.content?.highlight_en && parse(project?.content?.highlight_en)}
//             </p>
//           </Col>
//         </Row>
//       </Container>
//       <Container


//       >
//         {/* Projects Section */}
//         <Row className={isSticky ? 'sticky-top' : ''} >
          
//           <Tab.Container id="left-tabs-example" defaultActiveKey="12" className={isSticky ? 'sticky-top' : ''}>
//             <Row>
//               <Col sm={3}>
//                 <Nav variant="pills" className= {`${isSticky ? 'mt-5' : 'mb-5'} flex-column`} >
//                   {project?.projects?.map((item) => {
//                     return (


//                       <Nav.Item className='mb-3'>
//                         <Nav.Link eventKey={item.id}>{item.category_title_en}</Nav.Link>
//                       </Nav.Item>
//                     )
//                   })}

//                 </Nav>
//               </Col>
//               <Col sm={9} className={isSticky ? 'mt-5' : ''}>
//                 <Tab.Content>
//                   {project?.projects?.map((item) => {
//                     return (

//                       <Tab.Pane eventKey={item.id}>
//                         <Row>

//                           {item.sections?.map((item,index) => {
//                             return (


//                               <Col
//                                 lg={6}
//                                 md={6}
//                                 sm={10}
//                                 key={index}
//                                 className="d-flex justify-content-center "
//                               >
//                                 <Card className="project-card h-100 shadow-sm">

//                                   <Card.Body>
//                                     <Card.Title className="heading-names">{item.section_title_en}</Card.Title>
//                                     <Card.Text>{item.description_en && parse(item.description_en)}</Card.Text>
//                                   </Card.Body>
//                                 </Card>
//                               </Col>
//                             )
//                           })}

//                         </Row>


//                       </Tab.Pane>
//                     )
//                   })}
//                 </Tab.Content>
//               </Col>
//             </Row>
//           </Tab.Container>
//         </Row>
//       </Container>

//       {/* Footer */}
//       <Footer />
//     </div>
//   );
// }

// export default Projects;


import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col, Card, Tab, Tabs, Nav } from 'react-bootstrap';
import Footer from './Footer';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import parse from 'html-react-parser';

function Projects() {
  const [activeTab, setActiveTab] = React.useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const [project, setProject] = useState(null);
  const [error, setError] = useState(null);

  const handleScroll = () => {
    setIsSticky(window.scrollY > 100);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fetch data with caching and error handling
  const fetchData = useCallback(async () => {
    try {
      const cachedData = localStorage.getItem('projectsData');
      if (cachedData) {
        setProject(JSON.parse(cachedData)); // Use cached data
      } else {
        const response = await axios.get('https://admin.techno-elevators.com/api/getProjectsPageDataBySlug/projects');
        const data = response.data.data;
        setProject(data);
        localStorage.setItem('projectsData', JSON.stringify(data)); // Cache the data
      }
    } catch (err) {
      setError('Failed to fetch data. Please try again later.');
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Helmet>
        <title>Projects | Best Escalators & Elevators For Sale in Oman</title>
        <meta name="description" content="Discover the future of vertical transport with Techno Elevators. You can trust us by looking at our projects done by our expert team." />
      </Helmet>

      <Container fluid>
        {/* Header Section */}
        <Row className="text-center mt-5 mb-3">
          <div className="section-title">
            <h2>Our Projects</h2>
          </div>
          <Col lg={12}>
            <p className="text-center" style={{ width: '700px', margin: 'auto' }}>
              {project?.content?.highlight_en && parse(project?.content?.highlight_en)}
            </p>
          </Col>
        </Row>
      </Container>

      <Container>
        {/* Projects Section */}
        <Row className={isSticky ? 'sticky-top' : ''}>
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab || '12'} className={isSticky ? 'sticky-top' : ''}>
            <Row>
              <Col sm={3}>
                <Nav variant="pills" className={`${isSticky ? 'mt-5' : 'mb-5'} flex-column`}>
                  {project?.projects?.map((item) => (
                    <Nav.Item className="mb-3" key={item.id}>
                      <Nav.Link eventKey={item.id}>{item.category_title_en}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>
              <Col sm={9} className={isSticky ? 'mt-5' : ''}>
                <Tab.Content>
                  {project?.projects?.map((item) => (
                    <Tab.Pane eventKey={item.id} key={item.id}>
                      <Row>
                        {item.sections?.map((section, index) => (
                          <Col lg={6} md={6} sm={10} key={index} className="d-flex justify-content-center">
                            <Card className="project-card h-100 shadow-sm">
                              <Card.Body>
                                <Card.Title className="heading-names">{section.section_title_en}</Card.Title>
                                <Card.Text>{section.description_en && parse(section.description_en)}</Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Row>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Projects;

